import useAuthStore from "store/authStore";
import useOverlayStore from "store/overlayStore";

const useCreateResourceModal = () => {
	const { hasRoles, hasPermissions } = useAuthStore();
	const {
		setShowCreateBook,
		setShowCreateUser,
		setShowCreateCategory,
		setShowCreateCollection,
		setShowCreateSubscription,
		setShowUploadBooks,
		setShowCreateSubjectGroups,
		setShowUploadUsers,
	} = useOverlayStore();

	const createBook = {
		label: "Book",
		command: () => setShowCreateBook(true),
		available:
			hasRoles([
				"Super Administrator",
				"Administrator",
				"Senior Publisher",
				"Publisher",
			]) && hasPermissions(["create book"]),
	};
	const uploadBooks = {
		label: "Upload books",
		command: () => setShowUploadBooks(true),
		available:
			hasRoles([
				"Super Administrator",
				"Administrator",
				"Senior Publisher",
				"Publisher",
			]) && hasPermissions(["create book"]),
	};
	const createUser = {
		label: "User",
		command: () => setShowCreateUser(true),
		available:
			hasRoles([
				"Super Administrator",
				"Administrator",
				"Senior Publisher",
				"Publisher",
				"Institution",
				"Educator",
				"Brand Ambassador",
			]) && hasPermissions(["create user"]),
	};
	const uploadUsers = {
		label: "Upload students",
		command: () => setShowUploadUsers(true),
		available: hasRoles(["Institution", "Educator"]),
	};
	const createSubjectGroup = {
		label: "Subject Group",
		command: () => setShowCreateSubjectGroups(true),
		available:
			hasRoles([
				"Super Administrator",
				"Administrator",
				"Institution",
				"Educator",
			]) && hasPermissions(["create subject group"]),
	};
	const createBookCategory = {
		label: "Book category",
		command: () => setShowCreateCategory(true),
		available:
			hasRoles(["Super Administrator", "Administrator"]) &&
			hasPermissions(["create book category"]),
	};
	const createBookCollection = {
		label: "Book collection",
		command: () => setShowCreateCollection(true),
		available:
			hasRoles(["Super Administrator", "Administrator"]) &&
			hasPermissions(["create book genre"]),
	};
	const createSubscriptionPlan = {
		label: "Subscription plan",
		command: () => setShowCreateSubscription(true),
		available:
			hasRoles(["Super Administrator", "Administrator"]) &&
			hasPermissions(["create subscription"]),
	};

	const items = [
		createBook,
		uploadBooks,
		createUser,
		uploadUsers,
		createSubjectGroup,
		createBookCategory,
		createBookCollection,
		createSubscriptionPlan,
	]?.filter((items) => items.available);

	return items;
};

export default useCreateResourceModal;
